import { IconButton, Tooltip } from "@mui/material"
import { ShowJustifyEditButton, TaskEditJustification } from "event-definitions"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Frag } from "lib/@components/slot/frag"
import { If } from "lib/@components/switch"
import { alert } from "lib/@dialogs/alert"
import noop from "lib/noop"
import { prevent } from "lib/prevent"
import Iconify from "minimals-template/components/Iconify"
import { useState } from "react"
import { isInRegime } from "routes/facilities/lib/when-parent-item"

export function JustifyChangeButton({ item }) {
    const { editMode } = useBoundContext()
    const { taskId } = item
    const [isActive, setIsActive] = useState(false)
    const [override, setOverride] = useState(false)
    const [canAddJustification, setCanAddJustification] = useState(false)
    const [newTask, setNewTask] = useState(false)
    const { parentItem } = useBoundContext()

    const inRegime = isInRegime(parentItem)

    ShowJustifyEditButton.useEvent(
        ({ taskId, isActive, overrideTip, hasChanged, isNewTask }) => {
            if (taskId !== item.taskId) return
            setIsActive(isActive)
            setOverride(overrideTip)
            setCanAddJustification(hasChanged)
            setNewTask(isNewTask)
        },
        [item.taskId]
    )

    const title = isActive ? "Add justification" : "Nothing to justify"

    if (override) return <Frag />
    if (!editMode) return <Frag />

    return (
        <If not truthy={inRegime}>
            <Tooltip title={title}>
                <span onClick={prevent(noop)}>
                    <IconButton
                        aria-label="Add justification"
                        color="primary"
                        onClick={prevent(addOrNoChangeAlert)}
                        size="small"
                        data-cy="add-reason-button"
                    >
                        <Iconify icon="iconoir:chat-plus-in" />
                    </IconButton>
                </span>
            </Tooltip>
        </If>
    )

    async function addOrNoChangeAlert() {
        if (canAddJustification || newTask) {
            TaskEditJustification.raiseOnce({ taskId })
        } else {
            await alert(
                "To be able to leave a justification, you must first change something on the task.",
                "Make a change and leave a justification"
            )
        }
    }
}
